import { http } from './config'

export default {
  getDataIntegrations: () => {
    return http.get('data_integrations')
  },

  getDataIntegrationsByLocality: (params) => {
    return http.get('data_integrations/by_locality/', { params })
  },

  finalizeDataIntegration: (dataIntegrationId) => {
    return http.post('data_integrations/' + dataIntegrationId + '/finalize')
  },

  getLastDataIntegrationDate: (localityId) => {
    return http.get('data_integrations/last_data_integration_date/?locality_id=' + localityId)
  },
}
